import React, { Component } from 'react';
import { TaulaResultatsContainer, TaulaCapes, NoResults } from './TaulaResultatsCercaElements';
import TablePagination from '@mui/material/TablePagination';
import ResultatInfoCard from './ResultatInfoCard';
import { getTranslatedKey } from '../../Utils/TranslateUtils';

class TaulaResultatsCerca extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  UNSAFE_componentWillReceiveProps = (next) => {
    if (this.props.isCapes !== next.isCapes) {
      this.props.handleChangePage(null, 0);
    }
  };

  findAtributEnriquit = (layers, layerName) => {
    for (let i = 0; i < layers?.length; i++) {
      const layer = layers[i];
      if (layer.Name === layerName) {
        return layer.Extension?.AtributEnriquit || null;
      }
      if (layer.Layer) {
        const enriquit = this.findAtributEnriquit(layer.Layer, layerName);
        if (enriquit) {
          return enriquit;
        }
      }
    }
    return null;
  };

  getElementsInfoAux = (element) => {
    const layerTitle = this.props.sitepLayerInfoMap.find((layer) => layer.getName() === element.Entitat)?.getTitle();
    const capa = getTranslatedKey('capa') + ': ' + (layerTitle || element.Titol);
    const atributEnriquit = this.findAtributEnriquit(this.props.sitepLayers, element.Entitat);

    if (atributEnriquit && element.Enriquit) return capa + ' - ' + atributEnriquit + ': ' + element.Enriquit;
    else return capa;
  };

  render() {
    return (
      <TaulaResultatsContainer id="taula-resultats-cerca">
        {this.props.elementsList.length === 0 ? (
          <NoResults>{getTranslatedKey('noResults')}</NoResults>
        ) : (
          <TaulaCapes id="body-taula-cerca">
            {this.props.elementsList.length > 0 &&
              this.props.elementsList.map((element, index) => {
                if (index < this.props.page * this.props.rowsPerPage + this.props.rowsPerPage && index >= this.props.rowsPerPage * this.props.page) {
                  return this.props.isCapes === 'capes' ? (
                    <ResultatInfoCard
                      isCapes={this.props.isCapes}
                      nomCapa={element.Title}
                      infoAux={element.Breadcrumb !== undefined ? element.Breadcrumb : ''}
                      capa={element}
                      key={index}
                      addLayerToLlegenda={(capa) => this.props.addLayerToLlegenda(capa)}
                      onClickElementCerca={(coords, isGeolocalitzacio, isETRS, isElement, id, name) =>
                        this.props.onClickElementCerca(coords, isGeolocalitzacio, isETRS, isElement, id, name)
                      }
                      fontSizeEnabled={this.props.fontSizeEnabled}
                    />
                  ) : this.props.isCapes === 'elements' ? (
                    <ResultatInfoCard
                      isCapes={this.props.isCapes}
                      nomCapa={element.Nom}
                      arCoords={[element.UtmX, element.UtmY]}
                      capa={element.Entitat}
                      identificador={element.Id}
                      infoAux={this.getElementsInfoAux(element)}
                      key={index}
                      onClickElementCerca={(coords, isGeolocalitzacio, isETRS, isElement, id, name) =>
                        this.props.onClickElementCerca(coords, isGeolocalitzacio, isETRS, isElement, id, name)
                      }
                      fontSizeEnabled={this.props.fontSizeEnabled}
                    />
                  ) : (
                    <ResultatInfoCard
                      clickAdreça={this.props.clickAdreça}
                      isCapes={this.props.isCapes}
                      nomCapa={element.isToponim ? (element.Nom !== undefined ? element.Nom['#text'] : element.AdrecaXY['#text']) : 'nom del cataleg'}
                      arCoords={element.isToponim ? element.CoordenadesETRS89UTM : ''}
                      infoAux={
                        element.isToponim && element.NomMunicipi !== undefined && element.NomMunicipi['#text'] !== ' '
                          ? getTranslatedKey('municipi') + ': ' + element.NomMunicipi['#text']
                          : element.isToponim && element.NomComarca !== undefined && element.NomComarca['#text'] !== ' '
                          ? getTranslatedKey('comarca') + ': ' + element.NomComarca['#text']
                          : getTranslatedKey('capaAdreça')
                      }
                      key={index}
                      onClickElementCerca={(coords, isGeolocalitzacio, isETRS, isElement, id, name) =>
                        this.props.onClickElementCerca(coords, isGeolocalitzacio, isETRS, isElement, id, name)
                      }
                      fontSizeEnabled={this.props.fontSizeEnabled}></ResultatInfoCard>
                  );
                } else return <></>;
              })}
          </TaulaCapes>
        )}
        <TablePagination
          component="div"
          count={this.props.totalRows}
          page={this.props.page}
          labelDisplayedRows={function defaultLabelDisplayedRows({ from, to, count }) {
            return `${from}–${to} de ${count !== -1 ? count : `more than ${to}`}`;
          }}
          onPageChange={(event, newPage) => this.props.handleChangePage(event, newPage)}
          rowsPerPage={this.props.rowsPerPage}
          showFirstButton={true}
          showLastButton={true}
          sx={{
            color: 'white',
            // position: 'absolute',
            bottom: '60px',
            right: window.innerWidth < 465 ? '18%' : window.innerWidth < 768 ? '5%' : '18%',
            '.MuiTablePagination-selectLabel': {
              display: 'none'
            },
            '.MuiInputBase-root': {
              display: 'none'
            },
            '.MuiToolbar-root': {
              bottom: '0',
              right: '0'
            },
            '.MuiTablePagination-root': {
              display: 'flex',
              justifyContent: window.innerWidth > 768 ? 'flex-end' : 'center',
              alignItems: 'center'
            },
            '.MuiTablePagination-displayedRows': {
              margin: 0
            },
            '.MuiIconButton-root': {
              color: 'white'
            },
            '.Mui-disabled': {
              color: '#666666 !important'
            }
          }}
        />
      </TaulaResultatsContainer>
    );
  }
}

export default TaulaResultatsCerca;
